import { ProjectAdministrationSubpage } from '../../../projectAdministrationLib';
import { SkuQuantityEntityListSpecification } from './SkuQuantityEntityListSpecification';

export class RequestEntityListSpecification extends SkuQuantityEntityListSpecification {
  constructor() {
    super(
      ProjectAdministrationSubpage.REQUESTLISTS,
      'Request list administration',
      'Request list',
      'Request lists',
      'REQ',
      {
        nonEditableContentReasons: ['Content of used request list cannot be edited.'],
      },
    );
  }
}
